<template>
<div class="preloader"><div class="spinner"></div></div> <!-- /.preloader -->

<div class="error-404-page">
    <div class="thm-container">
        <div class="row">
            <div class="col-md-7 col-sm-6 col-xs-12">

            </div><!-- /.col-md-7 -->
            <div class="col-md-5 col-sm-6 col-xs-12">
                <img src="img/404-man.png" alt="Awesome Image"/>
            </div><!-- /.col-md-5 -->
        </div><!-- /.row -->
    </div><!-- /.thm-container -->
</div><!-- /.error-404-page -->
</template>
<script>

export default {
  name: 'FalseA',
  components: {

  }
}
</script>
